module.exports = __webpack_public_path__ + "static/media/laptop-basic.59972b4c.png";